import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  GetTooltipsResponse,
  TooltipItem,
} from '@/app/common/api/types/tooltipsApiTypes';

const tooltipsApi = createApi({
  reducerPath: 'tooltipsApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  endpoints: (build) => ({
    getTooltips: build.query<TooltipItem[], void>({
      query: () => ({
        url: '/go_handler/v2/tooltips',
        method: 'GET',
      }),
      transformResponse: (response: GetTooltipsResponse) => response.data ?? [],
    }),
  }),
});

export const { useGetTooltipsQuery } = tooltipsApi;

export default tooltipsApi;
